import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InspectionPdfService, PdfShareLinkService } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-share-pdf-page',
  templateUrl: './share-pdf-page.component.html',
  styleUrls: ['./share-pdf-page.component.scss'],
})
export class SharePdfPageComponent {
  id: string = '';
  pdfUrl: SafeResourceUrl | undefined;
  pdfLoadFailed: boolean = false;

  private returnUrl: string = '/emails';

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private readonly inspectionPdfService: InspectionPdfService,
    private readonly pdfShareLinkService: PdfShareLinkService,
    private readonly sanitizer: DomSanitizer) {
    route.paramMap.subscribe((params) => {
      const rawReturnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
      this.returnUrl = this.safeInternalReturnUrl(rawReturnUrl) ?? '/emails';
      route.paramMap.subscribe((params) => {
        const id = params.get('id');
        if (id != null) {
          this.id = id;
          this.viewPdf(this.id);
        } else {
          this.pdfLoadFailed = true;
        }
      });
    });
  }

  async navigateBack(): Promise<void> {
    await this.router.navigateByUrl(this.returnUrl);
  }

  private safeInternalReturnUrl(raw: string | null): string | null {
    if (!raw) return null;
    if (raw.startsWith('/email/') || raw === '/email') return raw;
    if (raw.startsWith('/emails') || raw === '/emails') return raw;

    return null;
  }

  async viewPdf(shareLink: string): Promise<void> {
    this.pdfShareLinkService.viewPdf(shareLink).subscribe(
      (response) => {
        const blob = new Blob([response as BlobPart], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      },
      (error) => {
        console.error('Error fetching PDF', error);
        this.pdfLoadFailed = true;
      }
    );
  }
}
